import styled from 'styled-components'

export const ContentModal = styled.div`
  font-weight: 500;
  font-size: 18px;
  color: ${({ theme }) => theme.cor66} !important;
`

export const ContainerAlerta = styled.div`
  width: 100%;
  display: grid;
  gap: 16px;
  justify-items: center;
`

export const MensagemAlerta = styled.span`
  text-align: center;
  color: ${({ theme }) => theme.cor9}!important;
`

export const TituloAlerta = styled.h1`
  font-size: 20px;
  font-weight: 500;
  color: ${({ theme }) => theme.cor9}!important;
`

export const SpanCinza = styled.span`
  color: ${({ theme }) => theme.designSystem.text.dimmed};
`
